import { DateUnit, RelativeDateDirection, type RelativeDate } from '@reach/shared-types/conditions';
import React from 'react';
import styles from './SegmentVisualBuilder.module.css';

interface RelativeDateBuilderProps {
  value: RelativeDate | null;
  onChange: (value: RelativeDate) => void;
  disabled?: boolean;
}

/**
 * UI for "N days before/after today" date inputs.
 */
export const RelativeDateBuilder: React.FC<RelativeDateBuilderProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const num = value?.value ?? 0;
  const direction = value?.direction ?? RelativeDateDirection.BEFORE;

  const handleNumChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const n = parseInt(e.target.value, 10);
    if (!Number.isNaN(n) && n >= 0) {
      onChange({
        type: 'relative',
        value: n,
        unit: DateUnit.DAYS,
        direction,
      });
    }
  };

  const handleDirectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const d =
      e.target.value === RelativeDateDirection.AFTER
        ? RelativeDateDirection.AFTER
        : RelativeDateDirection.BEFORE;
    onChange({
      type: 'relative',
      value: num,
      unit: DateUnit.DAYS,
      direction: d,
    });
  };

  return (
    <div className={styles.relatedCountRow} style={{ marginBottom: 0 }}>
      <input
        type="number"
        min={0}
        value={num}
        onChange={handleNumChange}
        disabled={disabled}
        className={styles.textInput}
        style={{ width: '4rem' }}
        aria-label="Number of days"
      />
      <span>days</span>
      <select
        className={styles.selectInput}
        value={direction}
        onChange={handleDirectionChange}
        disabled={disabled}
        style={{ width: 'auto' }}
        aria-label="Before or after today">
        <option value={RelativeDateDirection.BEFORE}>ago (before today)</option>
        <option value={RelativeDateDirection.AFTER}>from now (after today)</option>
      </select>
    </div>
  );
};
